import { render, staticRenderFns } from "./CleaningTaskView.vue?vue&type=template&id=6c71bbd8&scoped=true&"
import script from "./CleaningTaskView.vue?vue&type=script&lang=js&"
export * from "./CleaningTaskView.vue?vue&type=script&lang=js&"
import style0 from "./CleaningTaskView.vue?vue&type=style&index=0&id=6c71bbd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71bbd8",
  null
  
)

export default component.exports